import * as d3 from 'd3'

export default {
  data: () => ({
    selectedItems: null,
    getItems: null,
  }),

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
  },

  methods: {
    set_selectedItems() {
      this.selectedItems = {
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },

    draw_PDF() {
      d3.select(`#btns_${this.localId}`).remove()
    },
  }
}